module.exports = __webpack_public_path__ + "img/icon-orders-billed-to.098a416.svg";